import React, { useState } from "react";
import { CSVLink } from "react-csv";

import classNames from "classnames";

import { useAppSelector } from "../../../../hooks/reduxHooks";
import { defaultDateTimeFormat } from "../../../../lib/utils";
import { IMasterTournament } from "../../../../types/api";
import { CSVData, ICalendarEvent } from "../../../../types/shared";

const DownloadButton = ({
    tournament,
    events,
}: {
    tournament?: IMasterTournament;
    events: ICalendarEvent[];
}): React.JSX.Element => {
    const { fields } = useAppSelector(state => state.global);

    const [csvData, setCSVData] = useState<Array<CSVData>>([]);
    const CSVHeaders = [
        { label: "Date", key: "date" },
        { label: "Age", key: "age" },
        { label: "Field", key: "field" },
        { label: "Team 1", key: "team1" },
        { label: "Team 2", key: "team2" },
        { label: "Umpire 1", key: "ump1" },
        { label: "Umpire 1 Phone", key: "ump1phone" },
        { label: "Umpire 2", key: "ump2" },
        { label: "Umpire 2 Phone", key: "ump2phone" },
    ];

    const generateCSVRow = (e: ICalendarEvent): CSVData => {
        const ump1 = e.umpires?.find(u => u.location === "plate");
        const ump2 = e.umpires?.find(u => u.location === "field");

        return {
            date: defaultDateTimeFormat.format(new Date(e.start)),
            age: e.ageLevel,
            field: fields
                .find(f => f.id === tournament?.field.id)
                ?.diamonds.find(d => d.id === e.resourceId)?.name,
            team1: e.visitor?.name || "TBD",
            team2: e.home?.name || "TBD",
            ump1: ump1 ? ump1.name : undefined,
            ump1phone: ump1 ? ump1.phone : undefined,
            ump2: ump2 ? ump2.name : undefined,
            ump2phone: ump2 ? ump2.phone : undefined,
        };
    };

    const handleDownload = () => {
        const CSVData = events.map(e => generateCSVRow(e));
        setCSVData(CSVData);
    };

    return (
        <CSVLink
            data={csvData}
            headers={CSVHeaders}
            filename={`${tournament?.name}.${new Date().getTime()}.csv`}
            className={classNames([
                "btn",
                "btn-primary",
                "scheduleConfirmButton",
            ])}
            target="_blank"
            onClick={handleDownload}
        >
            Download Tournament Schedule
        </CSVLink>
    );
};

export default DownloadButton;
